import React from "react";
import AppStrokeIcon, { type IAppNavIconProps } from "./AppStrokeIcon";

/** `search_icon.svg`. */
const ExploreIcon: React.FC<IAppNavIconProps> = (props) => (
  <AppStrokeIcon {...props}>
    <path d="M11.5 21C16.75 21 21 16.75 21 11.5C21 6.25 16.75 2 11.5 2C6.25 2 2 6.25 2 11.5C2 16.75 6.25 21 11.5 21Z" />
    <path d="M22 22L20 20" />
  </AppStrokeIcon>
);

export default ExploreIcon;
